<div [ngClass]="isReadonly ? 'read-only' : ''">
    <header class="d-flex align-items-center px-0 py-3 justify-content-center">
        <div [title]="moduleTitle">{{ moduleTitle }}</div>
    </header>
    <main>
        <div class="inputs position-relative d-inline-block overflow-hidden">
            <div *ngIf="!isReadonly" class="d-flex justify-content-start cursor-pointer">
                <button
                    type="button"
                    class="btn ca-btn-icon ca-btn-icon-small plus-button-right me-2"
                    (click)="addInput()"
                    data-uit="add-input"
                    [title]="'GENERAL.ADD' | translate"
                    [ngbTooltip]="'GENERAL.ADD' | translate"
                    container="body"
                >
                    <ca-icon name="plus-filled" size="s" class="ca-color-icon-plus-filled-secondary" [removeSVGAttributes]="['stroke']"></ca-icon>
                </button>
                <div (click)="addInput()" class="text-white ps-2">{{ 'MODULES.SPEC_GENERATION.ADD_INPUT' | translate }}</div>
            </div>
            <a
                *ngFor="let property of inputs"
                class="input"
                data-uit="input"
                [class.active]="isPropertyActive(property)"
                [class.invalid]="isPropertyActive(property) && !isFormValid"
                [ngbTooltip]="getTooltip(property)"
                container="body"
            >
                <span (click)="setActiveProperty(property)" class="d-flex justify-content-start align-items-center overflow-hidden">
                    <small class="font-sm d-block overflow-hidden">{{ property.label }}</small>
                    <button
                        *ngIf="!propertyDefinitionComplete"
                        type="button"
                        (click)="removeInput(property)"
                        class="btn ca-btn-icon ca-btn-icon-small delete-button"
                        data-uit="input-delete-button"
                        [ngbTooltip]="'GENERAL.DELETE' | translate"
                        container="body"
                    >
                        <ca-icon name="trash" size="s"></ca-icon>
                    </button>
                </span>
            </a>
        </div>
        <div class="outputs position-relative d-inline-block overflow-hidden">
            <div *ngIf="!isReadonly" class="d-flex justify-content-end cursor-pointer">
                <div (click)="addOutput()" class="text-white pe-2">{{ 'MODULES.SPEC_GENERATION.ADD_OUTPUT' | translate }}</div>
                <button
                    type="button"
                    (click)="addOutput()"
                    class="btn ca-btn-icon ca-btn-icon-small plus-button-left ms-2"
                    data-uit="add-output"
                    [title]="'GENERAL.ADD' | translate"
                    [ngbTooltip]="'GENERAL.ADD' | translate"
                    container="body"
                >
                    <ca-icon name="plus-filled" size="s" class="ca-color-icon-plus-filled-secondary" [removeSVGAttributes]="['stroke']"></ca-icon>
                </button>
            </div>
            <a
                *ngFor="let property of outputs"
                class="output flex-row-reverse"
                data-uit="output"
                [class.active]="isPropertyActive(property)"
                [class.invalid]="isPropertyActive(property) && !isFormValid"
                [ngbTooltip]="getTooltip(property)"
                container="body"
            >
                <span (click)="setActiveProperty(property)" class="d-flex justify-content-end">
                    <button
                        *ngIf="!propertyDefinitionComplete"
                        type="button"
                        (click)="removeOutput(property)"
                        class="btn ca-btn-icon ca-btn-icon-small delete-button"
                        data-uit="output-delete-button"
                        [ngbTooltip]="'GENERAL.DELETE' | translate"
                        container="body"
                    >
                        <ca-icon name="trash" size="s"></ca-icon>
                    </button>
                    <small class="font-sm d-flex align-items-center overflow-hidden text-end">{{ property.label }}</small>
                </span>
            </a>
        </div>
    </main>
</div>
